import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const List = ({ cards, handlePrimaryValue, isChecked }) => {
  return (
    <>
      {/* <PageHeaderTitle title="Card List" /> */}
      {/* <PageContainer> */}
      <div className="p-8 rounded-2xl border mt-8 bg-[#FBFCFC] border-white-500 max-w-[60rem] mx-auto">
        {/* Main container for cards */}
        <div className="flex flex-col space-y-4">
          {cards && cards.length > 0 ? (
            cards.map((val) => (
              <div
                className="flex items-center justify-between border rounded-md p-4"
                key={val.id}
              >
                <div className="flex items-center space-x-2">
                  <FontAwesomeIcon
                    icon={faCreditCard}
                    style={{ color: "green" }}
                  />
                  <div>
                    {/* <p>{val?.name_on_card}</p> */}
                    <p>{"**** **** ****" + val?.last_four_digit}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-5  obtn">
                  <input
                    className="ml-5"
                    name="primaryCard"
                    type="radio"
                    id={val.id}
                    checked={isChecked === val.is_active}
                    onChange={() => handlePrimaryValue(val)}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
              <p>No cards found</p>
            </div>
          )}
        </div>
      </div>
      {/* </PageContainer> */}
    </>
  );
};

export default List;
